import { Module } from "plugins/_application";
var $ = jQuery;

export default class MaterialSearch extends Module {

	ready(app) {
        let q = this.findGetParameter('q');
        let view = this.findGetParameter('view');
        if(!view) {
            let searchField = $('input.search');
            if (searchField.length && q) {
                searchField = searchField[0];
                $(searchField).attr('value', q.replace(/[+]/gm, ' '));
                $('.button.wider.red.uppercase.auto').click();
            }
        }
    }

    findGetParameter(parameterName) {
        var result = null,
            tmp = [];
        location.search
            .substr(1)
            .split("&")
            .forEach(function (item) {
                tmp = item.split("=");
                if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
            });
        return result;
    }
}